// extracted by mini-css-extract-plugin
module.exports = {"messageWrapper":"InfoErrorMessage_messageWrapper__22jPm"};